/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";
import { Typography, Button, useWindowSize, Modal, ScalableImage } from "design_system/src";
import { ReactComponent as Arrow } from "design_system/src/static/icons/up-lg.svg";

import "./Banner.scss";
import { useDispatch } from "react-redux";
import {
  clearApplicationLoanTime,
  clearApplicationPartnership,
  clearApplicationVehicle,
} from "store/actions/application";

const uber = "UBER";
const didi = "DIDI";

const Banner: React.FC = () => {
  const bannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/repartidores_didifood_uber_descuento_credito";
  const tabletBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/moto_nueva_seminueva_repartidores_didifood_uber_descuento_medium";
  const desktopBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/estrena_moto_nueva_seminueva_trabajar_credito_repartidores_didifood_uber_descuento_large";

  const didiBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/repartidores_didifood_uber_descuento_xsmall";
  const didiTabletBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/nueva_repartidores_didifood_uber_descuento_medium";
  const didiDesktopBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/nueva_repartidores_didifood_uber_descuento_large";

  const { width: windowWidth } = useWindowSize();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<number>(0);

  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === 0 ? 1 : 0));
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const clickToFinancialForm = (alliedCompany: string  | null = null) => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationPartnership());

    if (alliedCompany) {
      ReactGA.event("CTA_discount_delivery_drivers", {
        category: "Financial Form",
        label: "click modal of delivery drivers discount",
        value: alliedCompany
      });
    }
  };

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? 1 : 0));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? 1 : 0));
  };

  return (
    <section className="dso_container_desktop">
      <div className="bannerSection">
        <div className="bannerSlider">
          <div className={`bannerBaseImg__container ${currentSlide === 0 ? "active" : ""}`}>
            <ScalableImage
              // eslint-disable-next-line no-nested-ternary
              src={windowWidth >= 1024 ? desktopBannerImg : windowWidth >= 600 ? tabletBannerImg : bannerImg}
              alt="Compra tu moto nueva o seminueva desde 240 pesos semanales. Crédito con Buró Flexible, paga en 1 año o hasta 156 semanas. Solo en CDMX."
              className="bannerBaseImg"
              desktopWidth={windowWidth >= 1024 ? 80 : 50}
              mobileWidth={100}
              loading="eager"
              fetchpriority="high"
            />
            <div className="bannerSection--pos-absolute">
              <div className="bannerButtons--center w_100_per h_100_per">
                <div className="h_50_per h_70_per_desktop display_flex flex_center">
                  <Link to="/financia-tu-moto" onClick={() => clickToFinancialForm()} className="w_100_per_mobile">
                    <Button
                      variant="principal"
                      scale={windowWidth > 800 || windowWidth < 600 ? "small" : "small"}
                      className="w_100_per_mobile"
                    >
                      <Typography weight="600" scale="small">Solicita tu crédito con descuento</Typography>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className={`bannerBaseImg__container ${currentSlide === 1 ? "active" : ""}`}>
            <ScalableImage
              // eslint-disable-next-line no-nested-ternary
              src={windowWidth >= 1024 ? didiDesktopBannerImg : windowWidth >= 600 ? didiTabletBannerImg : didiBannerImg}
              alt="Compra tu moto nueva o seminueva desde 240 pesos semanales. Crédito con Buró Flexible, paga en 1 año o hasta 156 semanas. Solo en CDMX."
              className="bannerBaseImg"
              desktopWidth={windowWidth >= 1024 ? 80 : 50}
              mobileWidth={50}
              loading="eager"
              fetchpriority="high"
            />
            <div className="bannerSection--pos-absolute">
              <div className="w_100_per h_100_per display_flex flex_justify_center flex_align_center flex_justify_start_desktop flex_align_end_desktop p_y_md_desktop p_x_md m_t_xxl_mobile">
                <div className="bannerButtons--left w_100_per_mobile display_flex flex_gap_md flex_col_mobile flex_justify_center flex_align_center">
                  <Button
                    variant="principal"
                    scale="small"
                    className="w_100_per_mobile"
                    onClick={() => setShowModal(true)}
                  >
                    <Typography weight="600" scale="small">¡Solicita tu crédito ahora!</Typography>
                  </Button>
                  <Link to="/catalogo" className="w_100_per_mobile">
                    <Button
                      color="grey"
                      orientation="right"
                      scale={windowWidth > 800 || windowWidth < 600 ? "small" : "small"}
                      className="w_100_per_mobile"
                    >
                      <Typography weight="600" scale="small">Ver catálogo de motos</Typography>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="bannerNavigation">
            <div className="bannerNavigation__dots">
              <div className={`bannerNavigation__dot ${currentSlide === 0 ? "active" : ""}`} />
              <div className={`bannerNavigation__dot ${currentSlide === 1 ? "active" : ""}`} />
            </div>
            <div className="bannerNavigation__buttons">
              <Button onClick={handlePrevSlide} className="bannerNavigation__button" aria-label="previous-image">
                <Arrow className="text_primary_300" style={{ "transform": "rotate(-90deg)" }} />
              </Button>
              <Button onClick={handleNextSlide} className="bannerNavigation__button" aria-label="next-image">
                <Arrow className="text_primary_300" style={{ "transform": "rotate(90deg)" }} />
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal open={showModal} setOpen={setShowModal} className="alliedCardModal">
        <Typography weight="600" scale="heading4" textColor="primary_300" className="text_center">Tenemos descuentos especiales para repartidores</Typography>
        <Typography weight="400" scale="medium" className="text_center">Selecciona en que plataforma te encuentras como repartidor:</Typography>
        <div className="display_flex flex_col_mobile flex_gap_md flex_align_center flex_justify_center m_t_md">
          <Link to={`/financia-tu-moto?alliedCompany=${uber}`} onClick={() => clickToFinancialForm(uber)} className="w_100_per_mobile alliedCard__link">
            <div className="alliedCard">
              <div style={{ height: "70px", width: "30%" }}>
                <ScalableImage
                  desktopWidth={5}
                  mobileWidth={5}
                  className="img_contain"
                  src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_uber"
                  alt="Por ser repartidor de Uber obtienes 7% de descuento en tu moto financiada"
                />
              </div>
              <Typography weight="600" scale="medium" className="text_center">Ahorra hasta $10,700</Typography>
            </div>
          </Link>
          <Link to={`/financia-tu-moto?alliedCompany=${didi}`} onClick={() => clickToFinancialForm(didi)} className="w_100_per_mobile alliedCard__link">
            <div className="alliedCard">
              <div style={{ height: "70px" }}>
                <ScalableImage
                  desktopWidth={5}
                  mobileWidth={5}
                  className="img_cover"
                  src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_DiDi"
                  alt="Por ser repartidor de DiDiFood obtienes 5% de descuento sobre el total del financiamiento"
                />
              </div>
              <Typography weight="600" scale="medium" className="text_center">Ahorra hasta $7,700</Typography>
            </div>
          </Link>
        </div>
      </Modal>
    </section>
  );
};

export default Banner;
